export default __webpack_public_path__ + "static/media/title-item.7f5465b9.png";